export default __webpack_public_path__ + "static/media/pitesti-card.7c6ab233.png";